var styleDataHash = "e4eefd23";
const injectCss = (() => {
  var css = `.qGRYY{margin-left:0;margin-right:auto;z-index:1}.qGRYY:not(.P7yqe){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.qGRYY:not(.P7yqe){float:none;margin-right:auto}}}@container (width < 480px){.qGRYY:not(.P7yqe){float:none;margin-right:auto}}._3JxL-{margin-left:auto;margin-right:0;z-index:1}._3JxL-:not(.P7yqe){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){._3JxL-:not(.P7yqe){float:none;margin-left:auto}}}@container (width < 480px){._3JxL-:not(.P7yqe){float:none;margin-left:auto}}.wyiOG{clear:both;display:block}.wyiOG:not(.f-eHP){margin-left:auto;margin-right:auto;max-width:100%}.P7yqe,.f-eHP{width:100%}.pwyqx .P7yqe,.pwyqx .f-eHP{margin:0 -8px;width:auto}.CaCBy{width:fit-content}.KfXRE{margin-left:auto;margin-right:auto;max-width:100%}.e-32h{width:min(350px,100%)!important}.pwyqx .e-32h{width:50%}.BLKh4{margin-left:auto;margin-right:auto}.pwyqx .BLKh4{width:150px}.eKdiP{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "qGRYY",
  "textWrapNowrap": "P7yqe",
  "alignRight": "_3JxL-",
  "alignCenter": "wyiOG",
  "sizeFullWidth": "f-eHP",
  "renderedInTable": "pwyqx",
  "sizeOriginal": "CaCBy",
  "sizeContent": "KfXRE",
  "sizeSmall": "e-32h",
  "sizeSmallCenter": "BLKh4",
  "flex": "eKdiP"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
